/* import __COLOCATED_TEMPLATE__ from './help.hbs'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import * as events from '@banking/ui/utils/bill-pay-cdp-events';
import { inject as service } from '@ember/service';
import { assertNonNullable } from '@banking/ui/utils/assert';
var AccordionItem = /*#__PURE__*/function (AccordionItem) {
  AccordionItem[AccordionItem["CARD"] = 0] = "CARD";
  AccordionItem[AccordionItem["DIRECT_DEPOSIT_ACCOUNT"] = 1] = "DIRECT_DEPOSIT_ACCOUNT";
  AccordionItem[AccordionItem["BILL_PAY"] = 2] = "BILL_PAY";
  AccordionItem[AccordionItem["WIRE_TRANSFER"] = 3] = "WIRE_TRANSFER";
  return AccordionItem;
}(AccordionItem || {});
function cdpEventFromAccordionToggle(item, toggle) {
  switch (item) {
    case AccordionItem.CARD:
      return events.BillPayHelp.clickToggleCardAccordion(toggle);
    case AccordionItem.DIRECT_DEPOSIT_ACCOUNT:
      return events.BillPayHelp.clickToggleDirectDepositAccountAccordion(toggle);
    case AccordionItem.BILL_PAY:
      return events.BillPayHelp.clickToggleBillPayAccordion(toggle);
    case AccordionItem.WIRE_TRANSFER:
      return events.BillPayHelp.clickToggleWireTransferAccordion(toggle);
    default:
      throw new Error(`Unrecognized AccordionItem enum value ${item}`);
  }
}
// TODO(steckel): internationalize for customers who may not have a direct
// deposit account.
// TODO(steckel): consider multiple card customers.
let Content = (_class = class Content extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "dataApi", _descriptor, this);
    _initializerDefineProperty(this, "sentry", _descriptor2, this);
    _defineProperty(this, "AccordionItem", AccordionItem);
  }
  // FIXME(steckel): Replace these "expanded" getters with a single enum value.
  get initialCardExpanded() {
    return this.cardData != null;
  }
  get initialDirectDepositAccountExpanded() {
    return !this.initialCardExpanded && this.directDepositAccountData != null;
  }
  get initialBillPayExpanded() {
    return !this.initialCardExpanded && !this.initialDirectDepositAccountExpanded;
  }
  get cardData() {
    return this.args.billPayData.card[0];
  }
  get directDepositAccountData() {
    return this.args.billPayData.directDepositAccount[0];
  }
  didInsert() {
    this.dataApi.track(...events.BillPayHelp.viewBillPayHelp({
      billPayExpanded: this.initialBillPayExpanded,
      cardEnabled: this.cardData != null,
      cardExpanded: this.initialCardExpanded,
      directDepositAccountEnabled: this.directDepositAccountData != null,
      directDepositAccountExpanded: this.initialDirectDepositAccountExpanded,
      wireTransferExpanded: false
    }));
  }
  onMarketAccordionItemExpandedChange(item, e) {
    try {
      const toggle = assertNonNullable(e.detail.expanded);
      // FIXME(steckel): migrate logic upward.
      // market-accordion-item does not implement the event.preventDefault
      // behavior one would expect so we must rely upon it to manage its own
      // state regardless of our preferences.
      if (!Object.prototype.hasOwnProperty.call(AccordionItem, item)) {
        throw new Error(`item: '${item}' is not an AccordionItem member`);
      }
      const accordionItems = document.querySelectorAll('market-accordion-item');
      if (e.detail.expanded) {
        accordionItems.forEach(accItem => {
          if (accItem === e.target) {
            accItem.setExpanded(true);
          } else {
            accItem.setExpanded(false);
          }
        });
      }
      const eventArgs = cdpEventFromAccordionToggle(item, toggle);
      this.dataApi.track(...eventArgs);
    } catch (err) {
      this.sentry.captureException(err);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "didInsert", [action], Object.getOwnPropertyDescriptor(_class.prototype, "didInsert"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onMarketAccordionItemExpandedChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onMarketAccordionItemExpandedChange"), _class.prototype), _class);
export { Content as default };